import React, { useState, useEffect, useCallback, useRef } from 'react'
import { Button } from '../../components/Button'
import Spinner from '../Spinner'
import { shortenAddress } from '../../utils'
import networks from '../../networks.json'
import { CHAIN_ID } from '../../constants'
import { getFixedStaking } from '../../api/contracts'

import {
  Modal,
  ModalContainer,
  ModalCloseButton,
  ModalForm,
  ModalButtonContainer,
  ModalButtonsContainer,
  ModalTitle,
  ModalText,
  ModalTxText,
  ModalTxLink,
  ModalSpinnerWrapper,
} from './UnstakeModal.styled'

export default function UnstakeModal({
  isOpen,
  onClose,
  staked,
  idx,
  earlyUnstakeFee,
  forceUpdate,
  setCardIsLoading,
  contractAddress,
  stakingHistory,
}) {
  const modal = useRef(null)
  const [isLoading, setIsLoading] = useState(false)
  const [txHash, setTxHash] = useState()

  const unstakeHandler = () => {
    const FixedStaking = getFixedStaking(contractAddress)
    if (staked) {
      setIsLoading(true)
      FixedStaking.unstake(idx)
        .then(tx => {
          setTxHash(tx.hash)
          tx.wait()
            .then(() => {
              setIsLoading(false)
              onClose()
              setCardIsLoading(true)
              forceUpdate()
            })
            .catch(err => {
              setIsLoading(false)
              console.log(err)
            })
        })
        .catch(err => {
          setIsLoading(false)
          console.log(err)
        })
    }
  }

  const handleOverlayClose = useCallback(event => {
    if (event.target === event.currentTarget) {
      onClose()
    }
  }, [])

  useEffect(() => {
    if (modal.current) {
      modal.current.addEventListener('click', handleOverlayClose)
    }
    return () => {
      if (modal.current) {
        modal.current.removeEventListener('click', handleOverlayClose)
      }
    }
  }, [handleOverlayClose])

  return (
    <Modal isOpen={isOpen} ref={modal}>
      <ModalContainer>
        <ModalButtonContainer
          onClick={() => {
            onClose()
          }}
        >
          <ModalCloseButton
            src={require('../../images/Close.svg').default}
            alt='close'
            width='14'
            height='14'
          ></ModalCloseButton>
        </ModalButtonContainer>
        <ModalTitle>Early Unstake penalty</ModalTitle>

        {isLoading ? (
          <>
            <ModalSpinnerWrapper>
              <Spinner size='80px' />
            </ModalSpinnerWrapper>
            {!txHash ? (
              <ModalTxText>Await confirmation</ModalTxText>
            ) : (
              <ModalTxLink
                target='_blank'
                href={`${networks[CHAIN_ID].params.blockExplorerUrls}tx/${txHash}`}
              >
                TxHash: {shortenAddress(txHash)}
              </ModalTxLink>
            )}
          </>
        ) : (
          <ModalForm>
            <ModalText>
              You are unstaking your MRUN before maturity date so you&apos;ll be
              charged Early Unstaking Penalty of{' '}
              {stakingHistory[idx] && stakingHistory[idx].charactersAmount > 0
                ? earlyUnstakeFee
                : earlyUnstakeFee / 4}{' '}
              %
            </ModalText>
            <ModalButtonsContainer>
              <Button
                variant='contained'
                size='modal'
                onClick={e => {
                  e.preventDefault()
                  onClose()
                }}
              >
                Cancel
              </Button>
              <Button
                variant='modal'
                size='modal'
                onClick={e => {
                  e.preventDefault()
                  unstakeHandler()
                }}
              >
                I Confirm Early Unstake
              </Button>
            </ModalButtonsContainer>
          </ModalForm>
        )}
      </ModalContainer>
    </Modal>
  )
}
